
import { DatadogWrapper, toDatadogRumUser } from 'Plugins/Datadog/DatadogWrapper';
import { StoreProvider } from '../../Configs/StoreProvider';
import { MeDto, MeResponse } from '../../Models/Users/Me';
import { MeApi } from '../Api/MeApi';
import { MeActions } from './MeActions';
import { Datadog } from 'Plugins/Datadog/Datadog';

const dispatch = (action: any) => StoreProvider.dispatch(action);

export class MeService {
    public static getMyInfo = async (): Promise<MeResponse | any> => {
        try {
            await dispatch(MeActions.setInfo(undefined));

            const response: MeResponse = await MeApi.getMyInfo();
            await MeService.setMyInfo(response.data);

            return Promise.resolve(response);
        } catch (error) {
            await dispatch(MeActions.setInfo(undefined));
            DatadogWrapper.RUM.setUser({});
            DatadogWrapper.RUM.addError(error);
            return Promise.reject(error);
        }
    };

    public static setMyInfo = async (meDto: MeDto): Promise<MeDto> => {
        try {
            await dispatch(MeActions.setInfo(meDto));
            DatadogWrapper.RUM.setUser(toDatadogRumUser(meDto));
            Datadog.initializeUsersWithoutConsent(meDto.type);
            return Promise.resolve(meDto);
        } catch (error) {
            await dispatch(MeActions.setInfo(undefined));
            DatadogWrapper.RUM.setUser({});
            DatadogWrapper.RUM.addError(error);
            return Promise.reject(error);
        }
    };
}
